var map = {
	"./apps/combinedContextLoader/combinedContextLoader.saga.js": 1240,
	"./apps/dashboard/actionlist/actionlist.saga.js": 1241,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.saga.js": 1242,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.saga.js": 1243,
	"./apps/workflow/workflowWidget/workflowWidget.saga.js": 1244,
	"./contexts/account/account.saga.js": 1245,
	"./contexts/document/document.saga.js": 1246,
	"./contexts/heading/heading.saga.js": 1247,
	"./contexts/instance/instance.saga.js": 1248,
	"./contexts/organisation/organisation.saga.js": 1249,
	"./contexts/project/dataTypes/groups/groups.saga.js": 1250,
	"./contexts/project/dataTypes/users/users.saga.js": 1251,
	"./contexts/project/project.saga.js": 1252,
	"./contexts/workflowinstance/workflowinstance.saga.js": 1253,
	"./globals/dataTypes/auth/auth.saga.js": 961,
	"./globals/dataTypes/comments/comments.saga.js": 1254,
	"./globals/dataTypes/login/login.saga.js": 348,
	"./globals/dataTypes/maintenance/data/data.saga.js": 1255,
	"./globals/dataTypes/notificationSettings/notificationSettings.saga.js": 962,
	"./globals/dataTypes/notifications/notifications.saga.js": 963,
	"./globals/dataTypes/performanceLogs/performanceLogs.saga.js": 1256,
	"./globals/dataTypes/projects/projects.saga.js": 1257,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.saga.js": 1258,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.saga.js": 964,
	"./globals/global.saga.js": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 930;